import { mainApiAxios } from '@/plugins/axios'

const DashboardService = {
    getSnapshot() {
        return mainApiAxios.get('dashboard/snapshot')
    },

    getSurvey(surveyId) {
        return mainApiAxios.get(`dashboard/surveys/${surveyId}`)
    },

    refresh() {
        return mainApiAxios.post('dashboard/refresh')
    },
}

// Data source handed to <DashboardShell>: unwraps the ApiResponseDto envelope and turns a
// 404 into an error carrying `status`, which the dashboard store uses to mark a survey missing.
export const dashboardApi = {
    getSnapshot() {
        return DashboardService.getSnapshot().then((res) => res.data)
    },

    getSurvey(surveyId) {
        return DashboardService.getSurvey(surveyId)
            .then((res) => res.data)
            .catch((error) => {
                const status = error && error.response ? error.response.status : undefined
                throw Object.assign(new Error(`survey ${surveyId} not available`), { status })
            })
    },

    // rebuilds the server cache from the database, then the caller reloads the snapshot
    refresh() {
        return DashboardService.refresh().then((res) => res.data)
    },

    // the strategic track (housing products / municipal services) has no database source yet
    getStrategic() {
        return Promise.resolve(null)
    },
}

export default DashboardService
